import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon, Table } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as customerController from '../../../../../../services/api/customer';
import ProgrammeInfoBtn from '../../../../../../components/ProgrammeInfoBtn/ProgrammeInfoBtn';
import CustomerInfoBtn from '../../../../../../components/CustomerInfoBtn/CustomerInfoBtn';
import './CustomerEnrollmentHistory.scss';

export class CustomerEnrollmentHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            leads: []
        }
    }

    fetchLeads() {
        const { match } = this.props;
        const customerId = match.params.customerId;

        customerController.getCustomerLeads(customerId)
            .then((res) => res.json())
            .then((json) => this.setState({ leads: json }))
    }

    componentDidMount() {
        this.fetchLeads();
    }

    render() {
        const { history } = this.props;
        const { leads } = this.state;
        const columns = [{
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            sorter: (a, b) => a.type.localeCompare(b.type),
        }, {
            title: 'Source',
            dataIndex: 'source',
            key: 'source',
            align: 'center',
            sorter: (a, b) => a.source.localeCompare(b.source),
        }, {
            title: 'Customer',
            dataIndex: 'customer',
            key: 'customer',
            render: (text, record) => <span>{text.name}<CustomerInfoBtn customerId={record.customer_id}/></span>,
            sorter: (a, b) => a.customer.localeCompare(b.customer),
        }, {
            title: 'Programme',
            dataIndex: 'interested_programme',
            key: 'interested_programme',
            render: (text, record) => text ? <span>{text.name}<ProgrammeInfoBtn programmeId={record.interested_programme_id}/></span> : '--',
            sorter: (a, b) => a.interested_programme.localeCompare(b.interested_programme),
        }, {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            sorter: (a, b) => a.status.localeCompare(b.status),
        }, {
            title: 'Next Follow Up',
            dataIndex: 'next_follow_up_date',
            key: 'next_follow_up_date',
            align: 'center',
            render: (text) => text ? moment(text).format('YYYY-MM-DD') : '--',
            sorter: (a, b) => {
                if (_.isEmpty(a.next_follow_up_date)) return 1;
                if (_.isEmpty(b.next_follow_up_date)) return -1;
                if (a.next_follow_up_date === b.next_follow_up_date) return 0;
                return a.next_follow_up_date - b.next_follow_up_date;
            }
        }, {
            title: 'Enrolled?',
            dataIndex: 'is_enrolled',
            key: 'is_enrolled',
            align: 'center',
            render: (text) => text ? <Icon type="check" /> : <Icon type="close" />,
            sorter: (a, b) => a.is_enrolled - b.is_enrolled,
        }, {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            render: (text, record) => (<Icon className="icon-btn" type="edit" onClick={() => history.push(`/dashboard/lead/${record.id}`)} />)
        }];

        return (
            <div className="CustomerEnrollmentHistory">
                <Table
					rowKey="id"
					columns={columns}
					dataSource={leads}
				/>
			</div>
        );
    }
}

export default withRouter(CustomerEnrollmentHistory);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/CustomerManagementPage/components/CustomerEnrollmentHistory/CustomerEnrollmentHistory.js